import {searchFetchLocations} from "./search-fetch-locations.js";
export class GlasContainerGeocoder {
  constructor() {
  }
  getCurrentPosition() {
    return new Promise((resolve, reject) => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((position) => {
          resolve({
            lat: position.coords.latitude,
            lng: position.coords.longitude
          });
        }, (error) => {
          console.error("Geolocation error:", error);
          reject(error);
        });
      } else {
        reject("Geolocation is not supported by this browser.");
      }
    });
  }
  async fetchGeocodeFromUser(userLocationInput) {
    let geocodeOptions = typeof userLocationInput === "string" ? {address: userLocationInput} : {location: userLocationInput};
    if (!this.geocoder) {
      this.geocoder = new google.maps.Geocoder();
    }
    try {
      const response = await this.geocoder.geocode(geocodeOptions);
      if (response.results[0]) {
        const result = {
          lat: response.results[0].geometry.location.lat(),
          lng: response.results[0].geometry.location.lng()
        };
        return {success: true, result};
      } else {
        return {success: false, error: "No results found"};
      }
    } catch (e) {
      return {success: false, error: `Geocoder failed due to: ${e}`};
    }
  }
  async fetchLocations(userLocationInput, locationUrl, radius) {
    try {
      const geocodeResult = await this.fetchGeocodeFromUser(userLocationInput);
      if (!geocodeResult.success || !geocodeResult.result) {
        return {success: false, error: "Geocoding failed"};
      }
      const locations = await searchFetchLocations(locationUrl, String(geocodeResult.result.lng), String(geocodeResult.result.lat), radius);
      return {
        success: true,
        locations,
        geocodeResult: geocodeResult.result
      };
    } catch (error) {
      console.error(error);
      return {success: false, error: error instanceof Error ? error.message : String(error)};
    }
  }
}
